import template from './chart.html';
import controller from './chart.controller';

const posChartComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default posChartComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/dashboard/pos/chart/chart.component.js
 **/